export default __webpack_public_path__ + "static/bigminerLogoSmall-5156a1cb8e8cbac9fc45f10cef59f70e.svg";